var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "c-btn c-btn--secondary c-btn--small block w-full",
      attrs: { href: "javascript:;" },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.logout()
        }
      }
    },
    [_vm._v("Logout")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }